module.exports = __webpack_public_path__ + "img/rate5.6b153c1c.svg";